import { Gauge } from "lucide-react";
import { useDataSaver } from "@/context/DataSaverContext";
import { useLang } from "@/context/LangContext";
import { ACCOUNT_UI as UI } from "@/data/accountI18n";

// Header button: toggles Mode Hemat Data (filled when active).
export const DataSaverToggle = ({ className = "" }) => {
  const { saver, setSaver } = useDataSaver();
  const { tc } = useLang();
  return (
    <button type="button" onClick={() => setSaver(!saver)} aria-pressed={saver} data-testid="data-saver-toggle" data-active={saver || undefined}
      title={tc(UI.dataSaverTitle)} aria-label={tc(UI.dataSaverTitle)}
      className={`relative flex h-10 w-10 items-center justify-center rounded-full border transition-colors ${saver ? "border-primary bg-primary text-primary-foreground" : "border-border/60 bg-card/70 text-foreground hover:bg-accent"} ${className}`}>
      <Gauge className="h-5 w-5" />
      {saver && <span className="absolute -top-0.5 -end-0.5 h-2.5 w-2.5 rounded-full bg-[hsl(var(--gold))] ring-2 ring-background" />}
    </button>
  );
};
